// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgClose24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M7.26906 6.21774L12 10.948L16.7309 6.21774C16.9949 5.95381 17.4079 5.92982 17.6989 6.14576L17.7823 6.21774C18.0726 6.50805 18.0726 6.97874 17.7823 7.26906L13.052 12L17.7823 16.7309C18.0726 17.0213 18.0726 17.492 17.7823 17.7823C17.492 18.0726 17.0213 18.0726 16.7309 17.7823L12 13.052L7.26906 17.7823C7.00513 18.0462 6.59214 18.0702 6.30111 17.8542L6.21774 17.7823C5.92742 17.492 5.92742 17.0213 6.21774 16.7309L10.948 12L6.21774 7.26906C5.92742 6.97874 5.92742 6.50805 6.21774 6.21774C6.50805 5.92742 6.97874 5.92742 7.26906 6.21774Z" />
			</Svg>
		);
	}
);
SvgClose24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgClose24;
